import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = { checkedRadios: Array };

  rememberState(event) {
    const { value, checked } = event.target;
    if (checked && !this.checkedRadiosValue.includes(value)) {
      this.checkedRadiosValue = [...this.checkedRadiosValue, value];
    }
  }

  toggle(event) {
    const radio = event.target;
    if (this.checkedRadiosValue.includes(radio.value)) {
      radio.checked = false;
      this.checkedRadiosValue = this.checkedRadiosValue.filter(v => v !== radio.value);
    }
  }
}
